import axios from 'axios'
import axiosConfig from './modules/axiosConfig'
import PageHome from './pages/Home.js'
import PageLogin from "./pages/Login";
import UseMouseOrKeyboard from "./modules/UseMouseOrKeyboard";
import DesignSystem from "./DesignSystem/DesignSystem";
import { register } from 'swiper/element/bundle';
import logs from "./utils/logs";
import ripple from "./modules/ripple";
import formErros from "./modules/formErros";
import animaAoScroll from "./animation/animaAoScroll";
import animateSetup from "./animation/animateSetup";
import EditorJS from './modules/EditorJS';
import Contact from './modules/Contact';
import Trabalhe_conosco from './modules/Trabalhe_conosco';
import Mailing from './modules/Mailing';
import Denuncia from './modules/Denuncia';
import Tabela_Performance from './modules/TabelaPerformance';
import Page_Conteudos from './pages/Conteudos';
import Page_fundos from './pages/Fundos';
import Page_invista_aqui from './pages/Invista_aqui';
import Page_Conteudos_Lista from './pages/Conteudos_Lista';
import Page_Quadro_Rentabilidade from "./pages/QuadroRentabilidade";

import YearNow from './modules/YearNow';

register()


// Init
GLOBAL.DesignSystem = DesignSystem({})

axiosConfig({ csrf: GLOBAL.context?.csrf }, axios)

Page_Conteudos();
Page_Conteudos_Lista();
Page_Quadro_Rentabilidade();
Page_fundos()

YearNow();
Contact();
Trabalhe_conosco();
Tabela_Performance();
Mailing();
Denuncia();
EditorJS();
Page_invista_aqui();


